import { DownloadOutlined } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { useLoanFilesHook } from "../../../hooks/useLoanFilesHook";

const DownloadPipelineAsZipButton = () => {
  const { loading, downloadPipeline } = useLoanFilesHook();

  const onDownloadClick = () => {
    downloadPipeline({
      fileDownloadName: "Pipeline Files",
    });
  };

  return (
    <Tooltip placement="bottom-start" title="Download Pipeline as ZIP">
      <IconButton
        loading={loading}
        onClick={onDownloadClick}
        size="small"
        color="primary"
      >
        <DownloadOutlined className="thin-7" sx={{ fontSize: 24 }} />
      </IconButton>
    </Tooltip>
  );
};

export default DownloadPipelineAsZipButton;
